var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import axios from './utils/axios';
import { getOriginalUser } from './utilisateur';
import { toUpperCaseFirstChar } from '../theme';
export var initSearch = function () {
    var originalUser = getOriginalUser();
    return {
        CollaborateurIds: originalUser.CollaborateurDefaultId
            ? [originalUser.CollaborateurDefaultId]
            : [],
        GroupeId: null,
        Debut: convertDateToYearMonth(new Date(new Date().getFullYear(), 0, 1)),
        Fin: convertDateToYearMonth(new Date(new Date().getFullYear(), 11, 1)),
        TagId: null,
    };
};
export var getYearAndMonthInStringDate = function (AnneeMois) {
    var Annee = Math.floor(AnneeMois / 100);
    var Mois = AnneeMois - Annee * 100;
    return { Annee: Annee, Mois: Mois };
};
export var converYearMonthToString = function (AnneeMois) {
    var dateString = new Date(Math.floor(AnneeMois / 100), AnneeMois - Math.floor(AnneeMois / 100) * 100 - 1).toLocaleString('fr-FR', {
        month: 'long',
        year: 'numeric',
    });
    return toUpperCaseFirstChar(dateString);
};
export var converMonthToString = function (Mois) {
    var dateString = new Date(1, Mois - 1).toLocaleString('fr-FR', {
        month: 'short',
    });
    return toUpperCaseFirstChar(dateString);
};
export var convertDateToYearMonth = function (date) {
    return date.getFullYear() * 100 + date.getMonth() + 1;
};
export function getFiltres() {
    return __awaiter(this, void 0, void 0, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, axios.get('/dashboard/getFiltres')];
                case 1:
                    data = (_a.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    });
}
export function getDerniersClients() {
    return __awaiter(this, void 0, void 0, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, axios.get('/dashboard/getDerniersClients')];
                case 1:
                    data = (_a.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    });
}
export function getActivites(_a) {
    var DateDebut = _a.DateDebut, DateFin = _a.DateFin, _b = _a.GroupeId, GroupeId = _b === void 0 ? null : _b, _c = _a.CollaborateurIds, CollaborateurIds = _c === void 0 ? null : _c, _d = _a.TagId, TagId = _d === void 0 ? null : _d;
    return __awaiter(this, void 0, void 0, function () {
        var data;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0: return [4 /*yield*/, axios.get('/dashboard/getActivites', {
                        params: {
                            DateDebut: DateDebut,
                            DateFin: DateFin,
                            GroupeId: GroupeId,
                            CollaborateurIds: CollaborateurIds,
                            TagId: TagId,
                        },
                    })];
                case 1:
                    data = (_e.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    });
}
export function getProchainesActivites(_a) {
    var _b = _a.GroupeId, GroupeId = _b === void 0 ? null : _b, _c = _a.CollaborateurIds, CollaborateurIds = _c === void 0 ? null : _c;
    return __awaiter(this, void 0, void 0, function () {
        var data;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0: return [4 /*yield*/, axios.get('/dashboard/getProchainesActivites?' +
                        (GroupeId ? '&GroupeId=' + GroupeId : '') +
                        (CollaborateurIds ? '&CollaborateurIds=' + CollaborateurIds : ''))];
                case 1:
                    data = (_d.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    });
}
export function getSynthese(_a) {
    var DateDebut = _a.DateDebut, DateFin = _a.DateFin, _b = _a.GroupeId, GroupeId = _b === void 0 ? null : _b, _c = _a.CollaborateurIds, CollaborateurIds = _c === void 0 ? null : _c, _d = _a.TagId, TagId = _d === void 0 ? null : _d;
    return __awaiter(this, void 0, void 0, function () {
        var data;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0: return [4 /*yield*/, axios.get('/dashboard/getSynthese', {
                        params: {
                            DateDebut: DateDebut,
                            DateFin: DateFin,
                            GroupeId: GroupeId,
                            CollaborateurIds: CollaborateurIds,
                            TagId: TagId,
                        },
                    })];
                case 1:
                    data = (_e.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    });
}
export function getForecast(_a) {
    var DateDebut = _a.DateDebut, DateFin = _a.DateFin, _b = _a.GroupeId, GroupeId = _b === void 0 ? null : _b, _c = _a.CollaborateurIds, CollaborateurIds = _c === void 0 ? null : _c, _d = _a.TagId, TagId = _d === void 0 ? null : _d;
    return __awaiter(this, void 0, void 0, function () {
        var data;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0: return [4 /*yield*/, axios.get('/dashboard/getForecast', {
                        params: {
                            DateDebut: DateDebut,
                            DateFin: DateFin,
                            GroupeId: GroupeId,
                            CollaborateurIds: CollaborateurIds,
                            TagId: TagId,
                        },
                    })];
                case 1:
                    data = (_e.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    });
}
export function getTotauxByTypeCatalogue(_a) {
    var DateDebut = _a.DateDebut, DateFin = _a.DateFin, _b = _a.GroupeId, GroupeId = _b === void 0 ? null : _b, _c = _a.CollaborateurIds, CollaborateurIds = _c === void 0 ? null : _c, _d = _a.TagId, TagId = _d === void 0 ? null : _d;
    return __awaiter(this, void 0, void 0, function () {
        var data;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0: return [4 /*yield*/, axios.get('/dashboard/getTotauxByTypeCatalogue', {
                        params: {
                            DateDebut: DateDebut,
                            DateFin: DateFin,
                            GroupeId: GroupeId,
                            CollaborateurIds: CollaborateurIds,
                            TagId: TagId,
                        },
                    })];
                case 1:
                    data = (_e.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    });
}
export function getTotauxByCatalogue(_a) {
    var DateDebut = _a.DateDebut, DateFin = _a.DateFin, _b = _a.GroupeId, GroupeId = _b === void 0 ? null : _b, _c = _a.CollaborateurIds, CollaborateurIds = _c === void 0 ? null : _c, _d = _a.TagId, TagId = _d === void 0 ? null : _d;
    return __awaiter(this, void 0, void 0, function () {
        var data;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0: return [4 /*yield*/, axios.get('/dashboard/getTotauxByCatalogue', {
                        params: {
                            DateDebut: DateDebut,
                            DateFin: DateFin,
                            GroupeId: GroupeId,
                            CollaborateurIds: CollaborateurIds,
                            TagId: TagId,
                        },
                    })];
                case 1:
                    data = (_e.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    });
}
export function getMixProduit(_a) {
    var DateDebut = _a.DateDebut, DateFin = _a.DateFin, _b = _a.GroupeId, GroupeId = _b === void 0 ? null : _b, _c = _a.CollaborateurIds, CollaborateurIds = _c === void 0 ? null : _c, _d = _a.TagId, TagId = _d === void 0 ? null : _d;
    return __awaiter(this, void 0, void 0, function () {
        var data;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0: return [4 /*yield*/, axios.get('/dashboard/getMixProduit', {
                        params: {
                            DateDebut: DateDebut,
                            DateFin: DateFin,
                            GroupeId: GroupeId,
                            CollaborateurIds: CollaborateurIds,
                            TagId: TagId,
                        },
                    })];
                case 1:
                    data = (_e.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    });
}
export function getPortefeuilleDetails(_a) {
    var DateDebut = _a.DateDebut, DateFin = _a.DateFin, _b = _a.GroupeId, GroupeId = _b === void 0 ? null : _b, _c = _a.CollaborateurIds, CollaborateurIds = _c === void 0 ? null : _c, _d = _a.TagId, TagId = _d === void 0 ? null : _d;
    return __awaiter(this, void 0, void 0, function () {
        var data;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0: return [4 /*yield*/, axios.get('/dashboard/getPortefeuilleDetails', {
                        params: {
                            DateDebut: DateDebut,
                            DateFin: DateFin,
                            GroupeId: GroupeId,
                            CollaborateurIds: CollaborateurIds,
                            TagId: TagId,
                        },
                    })];
                case 1:
                    data = (_e.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    });
}
export function getHitRatio(_a) {
    var DateDebut = _a.DateDebut, DateFin = _a.DateFin, _b = _a.GroupeId, GroupeId = _b === void 0 ? null : _b, _c = _a.CollaborateurIds, CollaborateurIds = _c === void 0 ? null : _c, _d = _a.TagId, TagId = _d === void 0 ? null : _d;
    return __awaiter(this, void 0, void 0, function () {
        var data;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0: return [4 /*yield*/, axios.get('/dashboard/getHitRatio', {
                        params: {
                            DateDebut: DateDebut,
                            DateFin: DateFin,
                            GroupeId: GroupeId,
                            CollaborateurIds: CollaborateurIds,
                            TagId: TagId,
                        },
                    })];
                case 1:
                    data = (_e.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    });
}
export function getTopAffaireGagnee(_a) {
    var DateDebut = _a.DateDebut, DateFin = _a.DateFin, _b = _a.GroupeId, GroupeId = _b === void 0 ? null : _b, _c = _a.CollaborateurIds, CollaborateurIds = _c === void 0 ? null : _c, _d = _a.TagId, TagId = _d === void 0 ? null : _d;
    return __awaiter(this, void 0, void 0, function () {
        var data;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0: return [4 /*yield*/, axios.get('/dashboard/getTopAffaireGagnee', {
                        params: {
                            DateDebut: DateDebut,
                            DateFin: DateFin,
                            GroupeId: GroupeId,
                            CollaborateurIds: CollaborateurIds,
                            TagId: TagId,
                        },
                    })];
                case 1:
                    data = (_e.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    });
}
export function getTopAffaireEnCours(_a) {
    var DateDebut = _a.DateDebut, DateFin = _a.DateFin, _b = _a.GroupeId, GroupeId = _b === void 0 ? null : _b, _c = _a.CollaborateurIds, CollaborateurIds = _c === void 0 ? null : _c, _d = _a.TagId, TagId = _d === void 0 ? null : _d;
    return __awaiter(this, void 0, void 0, function () {
        var data;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0: return [4 /*yield*/, axios.get('/dashboard/getTopAffaireEnCours', {
                        params: {
                            DateDebut: DateDebut,
                            DateFin: DateFin,
                            GroupeId: GroupeId,
                            CollaborateurIds: CollaborateurIds,
                            TagId: TagId,
                        },
                    })];
                case 1:
                    data = (_e.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    });
}
export function getTopClient(_a) {
    var DateDebut = _a.DateDebut, DateFin = _a.DateFin, _b = _a.GroupeId, GroupeId = _b === void 0 ? null : _b, _c = _a.CollaborateurIds, CollaborateurIds = _c === void 0 ? null : _c, _d = _a.TagId, TagId = _d === void 0 ? null : _d;
    return __awaiter(this, void 0, void 0, function () {
        var data;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0: return [4 /*yield*/, axios.get('/dashboard/getTopClient', {
                        params: {
                            DateDebut: DateDebut,
                            DateFin: DateFin,
                            GroupeId: GroupeId,
                            CollaborateurIds: CollaborateurIds,
                            TagId: TagId,
                        },
                    })];
                case 1:
                    data = (_e.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    });
}
export function getRecapitulatif(_a) {
    var DateDebut = _a.DateDebut, DateFin = _a.DateFin, _b = _a.GroupeId, GroupeId = _b === void 0 ? null : _b, _c = _a.CollaborateurIds, CollaborateurIds = _c === void 0 ? null : _c, _d = _a.TagId, TagId = _d === void 0 ? null : _d;
    return __awaiter(this, void 0, void 0, function () {
        var data;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0: return [4 /*yield*/, axios.get('/dashboard/getRecapitulatif', {
                        params: {
                            DateDebut: DateDebut,
                            DateFin: DateFin,
                            GroupeId: GroupeId,
                            CollaborateurIds: CollaborateurIds,
                            TagId: TagId,
                        },
                    })];
                case 1:
                    data = (_e.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    });
}
export function getTotaux(_a) {
    var DateDebut = _a.DateDebut, DateFin = _a.DateFin, _b = _a.GroupeId, GroupeId = _b === void 0 ? null : _b, _c = _a.CollaborateurIds, CollaborateurIds = _c === void 0 ? null : _c, _d = _a.TagId, TagId = _d === void 0 ? null : _d;
    return __awaiter(this, void 0, void 0, function () {
        var data;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0: return [4 /*yield*/, axios.get('/dashboard/getTotaux', {
                        params: {
                            DateDebut: DateDebut,
                            DateFin: DateFin,
                            GroupeId: GroupeId,
                            CollaborateurIds: CollaborateurIds,
                            TagId: TagId,
                        },
                    })];
                case 1:
                    data = (_e.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    });
}
export function getDynamique(_a) {
    var DateDebut = _a.DateDebut, DateFin = _a.DateFin, _b = _a.GroupeId, GroupeId = _b === void 0 ? null : _b, _c = _a.CollaborateurIds, CollaborateurIds = _c === void 0 ? null : _c, _d = _a.TagId, TagId = _d === void 0 ? null : _d;
    return __awaiter(this, void 0, void 0, function () {
        var data;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0: return [4 /*yield*/, axios.get('/dashboard/getDynamique', {
                        params: {
                            DateDebut: DateDebut,
                            DateFin: DateFin,
                            GroupeId: GroupeId,
                            CollaborateurIds: CollaborateurIds,
                            TagId: TagId,
                        },
                    })];
                case 1:
                    data = (_e.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    });
}
export function getKanban(type, _a) {
    var Debut = _a.Debut, Fin = _a.Fin, _b = _a.GroupeId, GroupeId = _b === void 0 ? null : _b, _c = _a.CollaborateurIds, CollaborateurIds = _c === void 0 ? null : _c;
    return __awaiter(this, void 0, void 0, function () {
        var data;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0: return [4 /*yield*/, axios.get('/dashboard/getKanban', {
                        params: {
                            type: type,
                            Debut: Debut,
                            Fin: Fin,
                            GroupeId: GroupeId,
                            CollaborateurIds: CollaborateurIds,
                        },
                    })];
                case 1:
                    data = (_d.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    });
}
//# sourceMappingURL=dashboard.js.map